import React from 'react';
import ReactDOM from 'react-dom';
import KeyHandler from 'react-key-handler';
import axios from 'axios';
import './index.css';
import clans from './clans.json';
import jQuery from 'jquery';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


class UnitBrowser extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			clans: clans,
			activeClan: clans[0],
			activeUnit: clans[0].units[0],
			lore: null,
		}
		for(var c=0;c<clans.length;c++) {
			preloadImage('/clans/db_'+clans[c].dbgroup+'.png');
			preloadImage('/clans/'+clans[c].code+'_banner.png');
			preloadImage('/clans/'+clans[c].code+'_border.png');
			for(var u=0;u<clans[c].units.length;u++) {
				preloadImage('/clans/'+clans[c].code+'_unit_'+clans[c].units[u].code+'_art.png');
				preloadImage('/clans/'+clans[c].code+'_unit_'+clans[c].units[u].code+'_card.jpg');
			}
		}
	}
	
	changeClan(clan, unit) {
		unit = unit || clan.units[0];
		this.setState({ activeClan: clan, activeUnit: unit, lore: null });
	}
	
	changeUnit(unit) {
		this.setState({ activeUnit: unit, lore: null });
	}
	
	changeLore(lore) {
		this.setState({ lore: lore });
	}
	
	shiftUnit(delta) {
		var clans = this.state.clans;
		var clanIndex = clans.indexOf(this.state.activeClan);
		var unitIndex = this.state.activeClan.units.indexOf(this.state.activeUnit);
		unitIndex += delta;
		if (unitIndex < 0) {
			clanIndex--;
			if(clanIndex < 0) {
				clanIndex = clans.length-1;
			}
			unitIndex = clans[clanIndex].units.length-1;
		} else if (unitIndex > clans[clanIndex].units.length-1) {
			unitIndex = 0;
			clanIndex++;
			if(clanIndex > clans.length-1) {
				clanIndex = 0;
			}
		}
		this.changeClan(clans[clanIndex], clans[clanIndex].units[unitIndex]);
	}
	
	render() {
		var headerstyle = { backgroundImage: "url(/clans/"+this.state.activeClan.code+"_banner.png)" };
		var selectorstyle = { backgroundImage: "url(/clans/"+this.state.activeClan.code+"_border.png)" };
		return (
			<div className="unit-browser">
				<div className="content">
					<ReactCSSTransitionGroup
						transitionName="fade"
						transitionEnterTimeout={1000}
						transitionLeaveTimeout={1000}>
							<div className="header" style={headerstyle} key={this.state.activeClan.code+"_header"}>
								<a href="https://www.plaidhatgames.com/store/374">
									<img className="logo" src="/logo.png" alt="Crystal Clans" />
								</a>
								<DBGroupDisplay value={this.state.activeClan.dbgroup} />
							</div>
					</ReactCSSTransitionGroup>
					<UnitDisplay
						clan={this.state.activeClan}
						unit={this.state.activeUnit}
						lore={this.state.lore}
						loreChanger={(l)=>this.changeLore(l)}
					/>
				</div>
				<ReactCSSTransitionGroup
					transitionName="fade"
					transitionEnterTimeout={1000}
					transitionLeaveTimeout={1000}>
					<div className="selector-container" style={selectorstyle} 
						key={this.state.activeClan.code+"_selector"}>
						<ClanSelector
							clans={this.state.clans}
							activeClan={this.state.activeClan}
							clanChanger={(c) => this.changeClan(c)}
						/>
						<UnitSelector
							clan={this.state.activeClan}
							activeUnit={this.state.activeUnit}
							unitChanger={(u) => this.changeUnit(u)}
						/>
					</div>
				</ReactCSSTransitionGroup>
				<ShiftUnitArrow orientation="left" onClick={() => this.shiftUnit(-1)} />
				<ShiftUnitArrow orientation="right" onClick={() => this.shiftUnit(1)} />
				<KeyHandler keyEventName="keyup" keyValue="ArrowLeft" onKeyHandle={() => this.shiftUnit(-1)} />
				<KeyHandler keyEventName="keyup" keyValue="ArrowRight" onKeyHandle={() => this.shiftUnit(1)} />
			</div>
		);
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		centerSelected(".clan-selector-option.selected", false, true);
		centerSelected(".unit-selector-option.selected", false, true);
	}
}

class ClanSelector extends React.Component {
	handleClick(clan) {
		if(clan) this.props.clanChanger(clan);
	}
	renderOption(clan, selected) {
		var seltext = "unselected";
		if(selected == 1) {
			seltext = "selected";
		}
		return (
			<ClanSelectorOption
				clan={clan}
				selected={seltext}
				onClick={() => this.handleClick(clan)}
			/>
		);
	}
	render() {
		var clanSelectorOptions = [];
		var clans = this.props.clans;
		for(var i=0;i<clans.length;i++) {
			var isSelected = 0;
			if(clans[i].code === this.props.activeClan.code) {
				isSelected = 1;
			}
			clanSelectorOptions.push(this.renderOption(clans[i],isSelected));
		}
		var leftStatus = "disabled";
		var leftClan = this.nextLeft();
		if(leftClan) {
			leftStatus = "enabled";
		}
		var rightStatus = "disabled";
		var rightClan = this.nextRight();
		if(rightClan) {
			rightStatus = "enabled";
		}
		return (
			<div className="clan-selector">
				<SelectorArrow
					orientation="left"
					enabled={leftStatus} 
					onClick={() => this.handleClick(leftClan)}
				/>
				<div className="options-container">
					<div className="options">{clanSelectorOptions}</div>
				</div>
				<SelectorArrow
					orientation="right"
					enabled={rightStatus}
					onClick={() => this.handleClick(rightClan)}
				/>
			</div>
		);
	}
	nextLeft() {
		var currentIndex = this.props.clans.indexOf(this.props.activeClan);
		if(currentIndex > 0) {
			return this.props.clans[currentIndex-1];
		}
		return null;
	}
	nextRight() {
		var currentIndex = this.props.clans.indexOf(this.props.activeClan);
		if(currentIndex > -1 && currentIndex < this.props.clans.length-1) {
			return this.props.clans[currentIndex+1];
		}
		return null;
	}
}

function ClanSelectorOption(props) {
	return (
		<div onClick={props.onClick} className={"clan-selector-option "+props.selected+" "+props.clan.code}>
			{props.clan.name}
		</div>
	);
}

class UnitSelector extends React.Component {
	handleClick(unit) {
		if(unit) this.props.unitChanger(unit);
	}
	renderOption(unit, selected) {
		var seltext = "unselected";
		if(selected == 1) {
			seltext = "selected";
		} else if (selected == -1) {
			seltext = "adjacent";
		}
		return (
			<UnitSelectorOption
				unit={unit}
				selected={seltext}
				onClick={() => this.handleClick(unit)}
			/>
		);
	}
	render() {
		var unitSelectorOptions = [];
		var units = this.props.clan.units;
		for(var i=0;i<units.length;i++) {
			var isSelected = 0;
			if(units[i].code === this.props.activeUnit.code) {
				isSelected = 1;
			} else if (i>0 && units[i-1].code === this.props.activeUnit.code) {
				isSelected = -1;
			} else if (i<units.length-1 && units[i+1].code === this.props.activeUnit.code) {
				isSelected = -1;
			}
			unitSelectorOptions.push(this.renderOption(units[i],isSelected));
		}
		var leftStatus = "disabled";
		var leftUnit = this.nextLeft();
		if(leftUnit) {
			leftStatus = "enabled";
		}
		var rightStatus = "disabled";
		var rightUnit = this.nextRight();
		if(rightUnit) {
			rightStatus = "enabled";
		}
		return (
			<div className={"unit-selector "+this.props.clan.code}>
				<SelectorArrow
					orientation="left"
					enabled={leftStatus} 
					onClick={() => this.handleClick(leftUnit)}
				/>
				<div className="options-container">
					<div className="options">{unitSelectorOptions}</div>
				</div>
				<SelectorArrow
					orientation="right"
					enabled={rightStatus} 
					onClick={() => this.handleClick(rightUnit)}
				/>
			</div>
		);
	}
	nextLeft() {
		var currentIndex = this.props.clan.units.indexOf(this.props.activeUnit);
		if(currentIndex > 0) {
			return this.props.clan.units[currentIndex-1];
		}
		return null;
	}
	nextRight() {
		var currentIndex = this.props.clan.units.indexOf(this.props.activeUnit);
		if(currentIndex > -1 && currentIndex < this.props.clan.units.length-1) {
			return this.props.clan.units[currentIndex+1];
		}
		return null;
	}
	
}


function UnitSelectorOption(props) {
	return (
		<div onClick={props.onClick} className={"unit-selector-option "+props.selected+" "+props.unit.code}>
			{props.unit.name}
		</div>
	);
}

function SelectorArrow(props) {
	return (
		<div
			onClick={props.onClick} 
			className={props.orientation+" arrow clan-selector-arrow "+props.enabled}
		></div>
	)
}

function ShiftUnitArrow(props) {
	return (
		<div
			onClick={props.onClick} 
			className={props.orientation+" arrow shift-unit-arrow enabled"}
		></div>
	)
}

function DBGroupDisplay(props) {
	return (
		<div className={"dbgroup "+props.value}>
			<img src={"/clans/db_"+props.value+".png"} alt={props.value} />
		</div>
	);
}

class UnitDisplay extends React.Component {
	render() {
		var ccode = this.props.clan.code;
		var ucode = this.props.unit.code;
		var loreenabled = "disabled";
		if (this.props.lore!==null) loreenabled="enabled";
		if(this.props.unit.story && this.props.lore === null){
			var $this = this;
			axios.get('/clans/'+ccode+"_unit_"+ucode+".txt")
		    .then(function (response) {
				if(response.status == "200") {
					$this.props.loreChanger(response.data);
				}
		    });
		}
		var artstyle = {};
		if(this.props.unit.left) {
			artstyle = { left: this.props.unit.left };
		}
		return (
			<div className={"unit-display "+ccode+"-"+ucode}>
				<div className={"unit-card "+ccode+"-"+ucode}>
					<img className="card-img"  src={"/clans/"+ccode+"_unit_"+ucode+"_card.jpg"} />			
				</div>
				<div className={"unit-lore "+ccode+"-"+ucode+" "+loreenabled}>{this.props.lore}</div>
				<ReactCSSTransitionGroup
					transitionName="fadeb"
					transitionEnterTimeout={1000}
					transitionLeaveTimeout={1000}>
					<div className={"unit-art "+ccode+"-"+ucode} style={artstyle} key={ccode+ucode}>
						<img src={"/clans/"+ccode+"_unit_"+ucode+"_art.png"} />
					</div>
				</ReactCSSTransitionGroup>			
			</div>
		);
	}
}

// ========================================

ReactDOM.render(
  <UnitBrowser />,
  document.getElementById('root')
);

function preloadImage(url) {
    const img = new Image();
    img.src = url;
}
function centerSelected(selected_selector, force, animate) {
	var selected = jQuery(selected_selector);
	var scroller = selected.parent();
	var container = scroller.parent();
	if(force || scroller.width() > container.width()) {
		var targetspot = container.width()/2 - selected.width()/2;
		var containerdifference = scroller.width() - container.width();
		var lefty = selected.position().left*-1+targetspot;
		if(lefty>0) {
			lefty=0;
		} else if(Math.abs(lefty)>containerdifference) {
			lefty=containerdifference*-1;
		}
		if (animate) {
			scroller.animate({"left":lefty+"px"});
		} else {
			scroller.css("left",lefty+"px");
		}
	}
}
jQuery(window).on('resize', function(){
	centerSelected(".clan-selector-option.selected", true, false);
	centerSelected(".unit-selector-option.selected", true, false);
});


// WEBPACK FOOTER //
// ./src/index.js